import React from 'react';

import { clsb } from '@core/js/utils/classNames.util';

import { clsx } from '@interlayer/js/app/utils/clsx.util';
import { useUnreadMessagesCount } from '@interlayer/js/components/system/CommunicationWidgets/buzz/hooks/useUnreadMessagesCount';

import { TInboxCounterProps } from './types';

import style from './InboxCounter.scss';

export const InboxCounter: React.FC<TInboxCounterProps> = ({ children, classNames = {}, className = '', type = '' }) => {
    const count = useUnreadMessagesCount(type);
    const buildCls = clsb([style, classNames]);

    if (!count) {
        return <>{children}</>;
    }

    return (
        <div
            data-testid="InboxCounter_wrapper"
            className={buildCls(['wrapper'])}
        >
            {children}

            <span className={clsx(style.counter, className)}>{count}</span>
        </div>
    );
};
